import { Text } from "@/components/ui/baseUi/text"
import { word } from "@/modules/core/utils/i18n"
import type { GroupedReactionDto } from "@/modules/social/gateway/socialDto"

type ReactionDisplayProps = {
  displayedReactions: GroupedReactionDto[]
  totalReactions: number
  commentsNumber?: number
  size?: "sm" | "md"
}

export function ReactionDisplay({
  displayedReactions,
  totalReactions,
  commentsNumber,
  size = "md",
}: ReactionDisplayProps) {
  const circleSize = size === "sm" ? "size-5 text-xs" : "size-7 text-md"

  return (
    <div className="flex items-center gap-2">
      {totalReactions > 0 && (
        <div className="flex items-center">
          {displayedReactions.map((reaction, index) => (
            <div
              key={reaction.emoji}
              className={`${circleSize} flex items-center justify-center rounded-full border border-(--social-reaction-orange) bg-surface-background-default`}
              style={{ marginLeft: index > 0 ? "-8px" : 0, zIndex: displayedReactions.length - index }}
            >
              <span className="leading-none">{reaction.emoji}</span>
            </div>
          ))}
        </div>
      )}

      <div className="flex flex-col gap-0">
        {totalReactions > 0 && (
          <Text fontStyle={size === "sm" ? "LS" : "LM"} className="text-textOnSurface-default">
            {word("social.reaction.likes", { count: totalReactions })}
          </Text>
        )}
        {commentsNumber != null && commentsNumber > 0 && (
          <Text fontStyle={size === "sm" ? "LS" : "LM"} className="text-textOnSurface-default">
            {word("social.reaction.comments", { count: commentsNumber })}
          </Text>
        )}
      </div>
    </div>
  )
}
